import EventsSerializer from './base';

export default class Risk extends EventsSerializer {}
